import React, { useEffect, useState } from 'react';
import { handleCheckoutMegapack, handleCheckoutUpsell } from '../utils/checkout';
import { Shield, Timer } from 'lucide-react';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const savedEndTime = sessionStorage.getItem('nerovix_countdown_end');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
    } else {
      endTime = new Date().getTime() + 2 * 60 * 60 * 1000 + 45 * 60 * 1000;
      sessionStorage.setItem('nerovix_countdown_end', endTime.toString());
    }
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      } else {
        setTimeLeft({
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const costData = [{
    problem: 'No client retention system',
    cost: 'Losing NZD $300–$800/month in drop-offs'
  }, {
    problem: 'No consultation close script',
    cost: '3 out of 5 leads walk away unconverted'
  }, {
    problem: 'No onboarding process',
    cost: 'Clients quit before they see results'
  }, {
    problem: 'No cancellation policy',
    cost: "Unpaid hours you'll never recover"
  }, {
    problem: 'No follow-up system',
    cost: 'Dead leads that should be paying clients'
  }, {
    problem: 'No pricing framework',
    cost: 'Same rate for another year — or two'
  }, {
    problem: 'No referral system',
    cost: 'Zero passive lead flow every month'
  }, {
    problem: 'No progress tracking',
    cost: "Clients don't see results — they leave"
  }, {
    problem: 'No business system at all',
    cost: 'You go back to a 9-to-5 by year 2'
  }];
  return <section className="bg-black py-16 md:py-24" data-id="element-29">
      <div className="max-w-4xl mx-auto px-4" data-id="element-30">
        {/* Real Cost Table */}
        <div className="mb-16" data-id="element-31">
          <h2 className="text-soft-gold text-2xl md:text-3xl font-bold text-center mb-8 font-playfair" data-id="element-32">
            ⚖️ THE REAL COST OF NOT HAVING A SYSTEM
          </h2>
          <div className="overflow-x-auto rounded-xl border border-nero-border shadow-lg" data-id="element-33">
            <table className="w-full text-left border-collapse" data-id="element-34">
              <thead data-id="element-35">
                <tr className="bg-soft-gold text-black" data-id="element-36">
                  <th className="p-4 font-bold w-1/2" data-id="element-37">The Missing Piece</th>
                  <th className="p-4 font-bold border-l border-black/10" data-id="element-38">
                    The Financial Cost
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-39">
                {costData.map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-[#0A0A0A]' : 'bg-[#111111]'} data-id="element-40">
                    <td className="p-4 text-white text-sm md:text-base border-t border-nero-border/30" data-id="element-41">
                      {row.problem}
                    </td>
                    <td className="p-4 text-red-400 text-sm md:text-base border-t border-l border-nero-border/30" data-id="element-42">
                      {row.cost}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Emotional Closing */}
        <div className="text-center mb-12 space-y-6" data-id="element-43">
          <p className="text-soft-gold italic text-2xl md:text-3xl font-bold font-playfair" data-id="element-44">
            "You didn't get certified to go back to a job you hate."
          </p>
          <p className="text-white text-base md:text-lg" data-id="element-45">
            You got certified because you genuinely believe you can change
            people's lives through coaching.
          </p>
          <p className="text-soft-gold text-lg md:text-xl font-bold" data-id="element-46">
            Don't let the lack of a business system be the reason that dream
            dies.
          </p>
          <p className="text-white text-base md:text-lg" data-id="element-47">
            The trainers who make it long-term aren't the most talented. They're
            the ones who built a system behind their passion.
          </p>
          <p className="text-soft-gold text-2xl md:text-3xl font-bold mt-8" data-id="element-48">
            This is yours. Right now. For NZD $24.49.
          </p>
        </div>

        {/* RED Countdown */}
        <div className="flex justify-center gap-4 mb-12" data-id="element-49">
          <div className="bg-red-600 text-white rounded-lg p-3 min-w-[70px] text-center shadow-lg" data-id="element-50">
            <span className="text-3xl font-bold font-mono" data-id="element-51">
              {String(timeLeft.hours).padStart(2, '0')}
            </span>
            <span className="block text-[10px] uppercase mt-1" data-id="element-52">Hours</span>
          </div>
          <div className="text-red-600 text-3xl font-bold py-2" data-id="element-53">:</div>
          <div className="bg-red-600 text-white rounded-lg p-3 min-w-[70px] text-center shadow-lg" data-id="element-54">
            <span className="text-3xl font-bold font-mono" data-id="element-55">
              {String(timeLeft.minutes).padStart(2, '0')}
            </span>
            <span className="block text-[10px] uppercase mt-1" data-id="element-56">Mins</span>
          </div>
          <div className="text-red-600 text-3xl font-bold py-2" data-id="element-57">:</div>
          <div className="bg-red-600 text-white rounded-lg p-3 min-w-[70px] text-center shadow-lg" data-id="element-58">
            <span className="text-3xl font-bold font-mono" data-id="element-59">
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
            <span className="block text-[10px] uppercase mt-1" data-id="element-60">Secs</span>
          </div>
        </div>

        {/* Dual Pricing Inline */}
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-61">
          <div className="bg-nero-card border border-nero-border rounded-xl p-6 text-center" data-id="element-62">
            <h3 className="text-white font-bold mb-2" data-id="element-63">Professional MegaPack</h3>
            <div className="mb-4" data-id="element-64">
              <span className="text-gray-500 line-through text-sm mr-2" data-id="element-65">
                NZD $67
              </span>
              <span className="text-soft-gold text-3xl font-bold" data-id="element-66">
                NZD $24.49
              </span>
            </div>
            <button onClick={handleCheckoutMegapack} className="w-full py-4 bg-soft-gold hover:bg-dark-gold text-black font-bold rounded-xl shadow-cta transition-all" data-id="element-67">
              GET MEGAPACK ONLY
            </button>
          </div>

          <div className="bg-nero-card border-2 border-soft-gold rounded-xl p-6 text-center relative" data-id="element-68">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-soft-gold text-black px-3 py-0.5 rounded-full text-[10px] font-bold tracking-wider" data-id="element-69">
              ⭐ MOST POPULAR
            </div>
            <h3 className="text-white font-bold mb-2" data-id="element-70">
              MegaPack + Client Acquisition Engine
            </h3>
            <div className="mb-4" data-id="element-71">
              <span className="text-gray-500 line-through text-sm mr-2" data-id="element-72">
                NZD $97
              </span>
              <span className="text-soft-gold text-3xl font-bold" data-id="element-73">
                NZD $34.99
              </span>
            </div>
            <button onClick={handleCheckoutUpsell} className="w-full py-4 bg-soft-gold hover:bg-dark-gold text-black font-bold rounded-xl shadow-cta transition-all transform hover:scale-105" data-id="element-74">
              GET THE COMPLETE BUNDLE
            </button>
          </div>
        </div>

        <div className="flex justify-center items-center gap-4 text-secondary-text text-xs mb-12" data-id="element-75">
          <Shield className="w-4 h-4" data-id="element-76" />
          <span data-id="element-77">Secure 256-bit Encryption • Powered by Shopify</span>
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-78">
          <p className="text-soft-gold italic text-base md:text-lg font-playfair" data-id="element-79">
            "The only thing worse than quitting... is wondering what would have
            happened if you had the right system."
          </p>
        </div>
      </div>
    </section>;
}